import React, { useState } from 'react';
import { Clear as ClearIcon } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

import ChargersTask from '../../../resources/ChargersTask';
import { ActionWrap } from './style';
import { makeErrorHandler } from '../../../resources/helper';

function CancelTaskAction(props) {
  const { task, alert } = props;
  const [state, setState] = useState({ loading: false });
  const { loading } = state;

  const click = () => {
    if (!loading) {
      setState({ loading: true });
      ChargersTask
        .cancel({ chargerId: task.chargerUuid, taskId: task.uuid })
        .then(() => alert('The task has been canceled successfully'))
        .catch(makeErrorHandler(alert, { 400: 'The task can not be canceled' }))
        .finally(() => setState({ loading: false }));
    }
  };

  return (
    <ActionWrap
      onClick={click}
      className={`link ${loading ? 'busy' : ''}`}
    >
      <CircularProgress size={10} />
      <ClearIcon />
      {' '}
      Cancel
    </ActionWrap>
  );
}

export default CancelTaskAction;
